// Filter reducer
const initialState = {
  search: "",
  tags: [],
  type: "ALL",
  creator: null
};
export const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_FILTER": {
      return {
        ...state,
        ...initialState
      };
    }
    case "SET_FILTER": {
      return {
        ...state,
        ...action.filter
      };
    }
    default:
      return state;
  }
};

// Tags reducer
const initialTagsSuggestionsState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null
};
export const tagsSuggestionsReducer = (
  state = initialTagsSuggestionsState,
  action
) => {
  switch (action.type) {
    case "INIT_TAGS_SUGGESTIONS": {
      return initialTagsSuggestionsState;
    }
    case "FETCH_TAGS_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_TAGS_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data.sort(function(a, b) {
          return a - b;
        })
      };
    }
    case "FETCH_TAGS_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filter.js